import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomSelect from '../common/CustomSelect';
import CommonInput from '../common/CommonInput';
import { arrayOptionsCarScale, arrayOptionsCarYear } from '../../../util/optionlist';

function PopupBtmModifyCarInfo({setisShowModifyCarInfo, setisCompleteCarinfo, carInfo, setcarInfo}) {
  const navigate = useNavigate();
  const [inputValueCarNumber, setinputValueCarNumber] = useState(carInfo.carNumber || '');
  const [inputValueCarName, setinputValueCarName] = useState(carInfo.carName || '');
  const [selectOptionCarScale, setselectOptionCarScale] = useState(carInfo.carScale || '');
  const [selectOptionCarYear, setselectOptionCarYear] = useState(carInfo.carYear || '');
  const [isFormComplete, setIsFormComplete] = useState(false);

  useEffect(() => {
    const isComplete =
      inputValueCarNumber.trim() !== '' &&
      inputValueCarName.trim() !== '' &&
      selectOptionCarScale !== '' &&
      selectOptionCarYear !== '';

    setIsFormComplete(isComplete);
  }, [inputValueCarNumber, inputValueCarName, selectOptionCarScale, selectOptionCarYear]);

  const handleComplete = () => {
    if (isFormComplete) {
      const updatedCarInfo = {
        ...carInfo,
        carNumber: inputValueCarNumber,
        carName: inputValueCarName,
        carScale: selectOptionCarScale,
        carYear: selectOptionCarYear
      };
      
      setcarInfo(updatedCarInfo);
      setisCompleteCarinfo(true);
      setisShowModifyCarInfo(false);
    }
  };

  const handleCancel = () => {
    setisShowModifyCarInfo(false);
  };


  // 스와이프 관련 상태
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const dragHandleRef = useRef(null); // 드래그 핸들(상단 바)을 위한 ref

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    // dragHandleRef가 터치 이벤트의 시작점을 포함하고 있는지 확인
    if (dragHandleRef.current?.contains(e.target)) {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientY);
    }
  };

  const onTouchMove = (e) => {
    // touchStart가 있을 때만 동작 (즉, 드래그 핸들에서 시작된 터치일 때만)
    if (touchStart) {
      setTouchEnd(e.targetTouches[0].clientY);
    }
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchEnd - touchStart;
    const isDownSwipe = distance > minSwipeDistance;
    
    if (isDownSwipe) {
      setisShowModifyCarInfo(false);
    }
  };

  return (
    <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10 ">
      <div
        className="bg-white w-full pb-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md max-h-[calc(100%-67px)] overflow-y-auto relative px-5"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {/* 드래그 핸들 영역에 ref 추가 */}
        <button 
          ref={dragHandleRef}
          className="absolute top-0 left-0 flex justify-center w-full h-10 pt-4 m-auto rounded-xl"
        >
          <span className="w-10 h-1 bg-[#E1E2E4] rounded-xl"></span>
        </button>
        <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] mb-4">
          사고 차량 정보
        </h3>

        <p className="text-[#46474C] text-[13px]">차량번호</p>
        <CommonInput
          inputValue={inputValueCarNumber}
          setInputValue={setinputValueCarNumber}
          placeholder={'ex) 122fn 1234'}
        />

        <p className="text-[#46474C] text-[13px] mt-4">차량명</p>
        <CommonInput
          inputValue={inputValueCarName}
          setInputValue={setinputValueCarName}
          placeholder={'ex) 벤츠 E33 2.0'}
        />

        <p className="text-[#46474C] text-[13px] mt-4">차량규모</p>
        <CustomSelect
          placeholder={'차량 규모를 선택해주세요'}
          selectOption={selectOptionCarScale}
          setselectOption={setselectOptionCarScale}
          options={arrayOptionsCarScale}
        />

        <p className="text-[#46474C] text-[13px] mt-4">연식</p>
        <CustomSelect
          placeholder={'연식을 선택해주세요'}
          selectOption={selectOptionCarYear}
          setselectOption={setselectOptionCarYear}
          options={arrayOptionsCarYear}
        />

        <div className="flex justify-between mt-8 gap-[10px]">
          <button
            className={`flex items-center justify-center w-full h-[52px] rounded-lg bg-[#F4F4F5] text-[#313A4C] font-semibold`}
            onClick={handleCancel}
          >
            취소
          </button>
          <button
            className={`flex items-center justify-center w-full h-[52px] rounded-lg ${
              isFormComplete ? 'bg-[#313A4C]' : 'bg-[#E1E2E4]'
            } text-white cursor-pointer font-semibold`}
            onClick={handleComplete}
            disabled={!isFormComplete}
          >
            완료
          </button>
        </div>
      </div>
    </div>
  );
}

export default PopupBtmModifyCarInfo;